/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 5.26.1
 * source: int/http/hall/h5.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */

/*
	此处请修改为Creator NpmExport路径
	请注意路径的层级
 */
import * as pb_1 from 'google-protobuf'
export namespace PackH5 {
  /**
      提现账号类型
       **/
  export enum WithdrawAccountType {
    UNKNOWN = 0,

    /**
          银行卡
           **/
    BANKCARD = 201,

    /**
          电话卡
           **/
    PhoneCard = 202,

    /**
          momo pay
           **/
    MOMO = 203,

    /**
          zalo pay
           **/
    ZALO = 204,

    /**
          one pay
           **/
    ONEPAY = 205,

    /**
          Ngan luong
           **/
    NganLuong = 206,

    /**
          PIX
           **/
    PIX = 207,

    /**
          UPI
           **/
    UPI = 208,

    /**
          电子钱包(虚拟类型)
           **/
    EWallet = 209,

    /**
          电子钱包(dana)
           **/
    EWalletDana = 210,

    /**
          电子钱包(ovo)
           **/
    EWalletOVO = 211,

    /**
          电子钱包(gopay)
           **/
    EWalletGopay = 212,
  }

  /**
      PIX账号类型
       **/
  export enum PixAccountType {
    PIX_UNKNOWN = 0,

    /**
          手机号
           **/
    PIX_PHONE = 1,

    /**
          邮箱
           **/
    PIX_EMAIL = 2,

    /**
          EVP
           **/
    PIX_EVP = 3,

    /**
          CPF
           **/
    PIX_CPF = 4,

    /**
          CNPJ
           **/
    PIX_CNPJ = 5,
  }

  /**
      通用请求头
       **/
  export class ReqHeader extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            timestamp?: number
            user_id?: number
            auth_token?: string
            brand_code?: string
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('timestamp' in data && data.timestamp != undefined) {
          this.timestamp = data.timestamp
        }
        if ('user_id' in data && data.user_id != undefined) {
          this.user_id = data.user_id
        }
        if ('auth_token' in data && data.auth_token != undefined) {
          this.auth_token = data.auth_token
        }
        if ('brand_code' in data && data.brand_code != undefined) {
          this.brand_code = data.brand_code
        }
      }
    }

    /**
          当前时间截
           **/
    get timestamp() {
      return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
    }

    /**
          当前时间截
           **/
    set timestamp(value: number) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          当前登录用户id
           **/
    get user_id() {
      return pb_1.Message.getFieldWithDefault(this, 2, 0) as number
    }

    /**
          当前登录用户id
           **/
    set user_id(value: number) {
      pb_1.Message.setField(this, 2, value)
    }

    /**
          授权凭证
           **/
    get auth_token() {
      return pb_1.Message.getFieldWithDefault(this, 3, '') as string
    }

    /**
          授权凭证
           **/
    set auth_token(value: string) {
      pb_1.Message.setField(this, 3, value)
    }

    /**
          品牌号
           **/
    get brand_code() {
      return pb_1.Message.getFieldWithDefault(this, 4, '') as string
    }

    /**
          品牌号
           **/
    set brand_code(value: string) {
      pb_1.Message.setField(this, 4, value)
    }
    static fromObject(data: {
      timestamp?: number
      user_id?: number
      auth_token?: string
      brand_code?: string
    }): ReqHeader {
      const message = new ReqHeader({})
      if (data.timestamp != null) {
        message.timestamp = data.timestamp
      }
      if (data.user_id != null) {
        message.user_id = data.user_id
      }
      if (data.auth_token != null) {
        message.auth_token = data.auth_token
      }
      if (data.brand_code != null) {
        message.brand_code = data.brand_code
      }
      return message
    }
    toObject() {
      const data: {
        timestamp?: number
        user_id?: number
        auth_token?: string
        brand_code?: string
      } = {}
      if (this.timestamp != null) {
        data.timestamp = this.timestamp
      }
      if (this.user_id != null) {
        data.user_id = this.user_id
      }
      if (this.auth_token != null) {
        data.auth_token = this.auth_token
      }
      if (this.brand_code != null) {
        data.brand_code = this.brand_code
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.timestamp != 0) writer.writeInt64(1, this.timestamp)
      if (this.user_id != 0) writer.writeInt64(2, this.user_id)
      if (this.auth_token.length) writer.writeString(3, this.auth_token)
      if (this.brand_code.length) writer.writeString(4, this.brand_code)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ReqHeader {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new ReqHeader()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.timestamp = reader.readInt64()
            break
          case 2:
            message.user_id = reader.readInt64()
            break
          case 3:
            message.auth_token = reader.readString()
            break
          case 4:
            message.brand_code = reader.readString()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): ReqHeader {
      return ReqHeader.deserialize(bytes)
    }
  }

  /**
      通用应答头
       **/
  export class RespHeader extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            code?: number
            trace_id?: string
            msg?: string
            timestamp?: number
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('code' in data && data.code != undefined) {
          this.code = data.code
        }
        if ('trace_id' in data && data.trace_id != undefined) {
          this.trace_id = data.trace_id
        }
        if ('msg' in data && data.msg != undefined) {
          this.msg = data.msg
        }
        if ('timestamp' in data && data.timestamp != undefined) {
          this.timestamp = data.timestamp
        }
      }
    }

    /**
          各模块接口定义的业务异常码
           **/
    get code() {
      return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
    }

    /**
          各模块接口定义的业务异常码
           **/
    set code(value: number) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          本次请求唯一事务id，用于问题追踪定位
           **/
    get trace_id() {
      return pb_1.Message.getFieldWithDefault(this, 2, '') as string
    }

    /**
          本次请求唯一事务id，用于问题追踪定位
           **/
    set trace_id(value: string) {
      pb_1.Message.setField(this, 2, value)
    }

    /**
          错误信息
           **/
    get msg() {
      return pb_1.Message.getFieldWithDefault(this, 3, '') as string
    }

    /**
          错误信息
           **/
    set msg(value: string) {
      pb_1.Message.setField(this, 3, value)
    }

    /**
          当前时间截
           **/
    get timestamp() {
      return pb_1.Message.getFieldWithDefault(this, 4, 0) as number
    }

    /**
          当前时间截
           **/
    set timestamp(value: number) {
      pb_1.Message.setField(this, 4, value)
    }
    static fromObject(data: {
      code?: number
      trace_id?: string
      msg?: string
      timestamp?: number
    }): RespHeader {
      const message = new RespHeader({})
      if (data.code != null) {
        message.code = data.code
      }
      if (data.trace_id != null) {
        message.trace_id = data.trace_id
      }
      if (data.msg != null) {
        message.msg = data.msg
      }
      if (data.timestamp != null) {
        message.timestamp = data.timestamp
      }
      return message
    }
    toObject() {
      const data: {
        code?: number
        trace_id?: string
        msg?: string
        timestamp?: number
      } = {}
      if (this.code != null) {
        data.code = this.code
      }
      if (this.trace_id != null) {
        data.trace_id = this.trace_id
      }
      if (this.msg != null) {
        data.msg = this.msg
      }
      if (this.timestamp != null) {
        data.timestamp = this.timestamp
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.code != 0) writer.writeInt32(1, this.code)
      if (this.trace_id.length) writer.writeString(2, this.trace_id)
      if (this.msg.length) writer.writeString(3, this.msg)
      if (this.timestamp != 0) writer.writeInt64(4, this.timestamp)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RespHeader {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new RespHeader()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.code = reader.readInt32()
            break
          case 2:
            message.trace_id = reader.readString()
            break
          case 3:
            message.msg = reader.readString()
            break
          case 4:
            message.timestamp = reader.readInt64()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): RespHeader {
      return RespHeader.deserialize(bytes)
    }
  }

  /**
      分页参数
       **/
  export class PaginationCriteria extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            page_no?: number
            page_size?: number
            return_total?: boolean
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('page_no' in data && data.page_no != undefined) {
          this.page_no = data.page_no
        }
        if ('page_size' in data && data.page_size != undefined) {
          this.page_size = data.page_size
        }
        if ('return_total' in data && data.return_total != undefined) {
          this.return_total = data.return_total
        }
      }
    }
    get page_no() {
      return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
    }
    set page_no(value: number) {
      pb_1.Message.setField(this, 1, value)
    }
    get page_size() {
      return pb_1.Message.getFieldWithDefault(this, 2, 0) as number
    }
    set page_size(value: number) {
      pb_1.Message.setField(this, 2, value)
    }
    get return_total() {
      return pb_1.Message.getFieldWithDefault(this, 3, false) as boolean
    }
    set return_total(value: boolean) {
      pb_1.Message.setField(this, 3, value)
    }
    static fromObject(data: {
      page_no?: number
      page_size?: number
      return_total?: boolean
    }): PaginationCriteria {
      const message = new PaginationCriteria({})
      if (data.page_no != null) {
        message.page_no = data.page_no
      }
      if (data.page_size != null) {
        message.page_size = data.page_size
      }
      if (data.return_total != null) {
        message.return_total = data.return_total
      }
      return message
    }
    toObject() {
      const data: {
        page_no?: number
        page_size?: number
        return_total?: boolean
      } = {}
      if (this.page_no != null) {
        data.page_no = this.page_no
      }
      if (this.page_size != null) {
        data.page_size = this.page_size
      }
      if (this.return_total != null) {
        data.return_total = this.return_total
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.page_no != 0) writer.writeInt32(1, this.page_no)
      if (this.page_size != 0) writer.writeInt32(2, this.page_size)
      if (this.return_total != false) writer.writeBool(3, this.return_total)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PaginationCriteria {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new PaginationCriteria()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.page_no = reader.readInt32()
            break
          case 2:
            message.page_size = reader.readInt32()
            break
          case 3:
            message.return_total = reader.readBool()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): PaginationCriteria {
      return PaginationCriteria.deserialize(bytes)
    }
  }

  /**
      /////////////////////////
       问卷系统
       act/survey/get/
       **/
  export class GetSurveyReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof ReqHeader.prototype.toObject>
    }): GetSurveyReq {
      const message = new GetSurveyReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSurveyReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new GetSurveyReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): GetSurveyReq {
      return GetSurveyReq.deserialize(bytes)
    }
  }
  export class SurveyConf extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            id?: number
            survey_id?: number
            survey_url?: string
            effected_at?: number
            expired_at?: number
            survey?: string
            created_at?: number
            updated_at?: number
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('id' in data && data.id != undefined) {
          this.id = data.id
        }
        if ('survey_id' in data && data.survey_id != undefined) {
          this.survey_id = data.survey_id
        }
        if ('survey_url' in data && data.survey_url != undefined) {
          this.survey_url = data.survey_url
        }
        if ('effected_at' in data && data.effected_at != undefined) {
          this.effected_at = data.effected_at
        }
        if ('expired_at' in data && data.expired_at != undefined) {
          this.expired_at = data.expired_at
        }
        if ('survey' in data && data.survey != undefined) {
          this.survey = data.survey
        }
        if ('created_at' in data && data.created_at != undefined) {
          this.created_at = data.created_at
        }
        if ('updated_at' in data && data.updated_at != undefined) {
          this.updated_at = data.updated_at
        }
      }
    }
    get id() {
      return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
    }
    set id(value: number) {
      pb_1.Message.setField(this, 1, value)
    }
    get survey_id() {
      return pb_1.Message.getFieldWithDefault(this, 2, 0) as number
    }
    set survey_id(value: number) {
      pb_1.Message.setField(this, 2, value)
    }
    get survey_url() {
      return pb_1.Message.getFieldWithDefault(this, 3, '') as string
    }
    set survey_url(value: string) {
      pb_1.Message.setField(this, 3, value)
    }
    get effected_at() {
      return pb_1.Message.getFieldWithDefault(this, 4, 0) as number
    }
    set effected_at(value: number) {
      pb_1.Message.setField(this, 4, value)
    }
    get expired_at() {
      return pb_1.Message.getFieldWithDefault(this, 5, 0) as number
    }
    set expired_at(value: number) {
      pb_1.Message.setField(this, 5, value)
    }
    get survey() {
      return pb_1.Message.getFieldWithDefault(this, 6, '') as string
    }
    set survey(value: string) {
      pb_1.Message.setField(this, 6, value)
    }
    get created_at() {
      return pb_1.Message.getFieldWithDefault(this, 7, 0) as number
    }
    set created_at(value: number) {
      pb_1.Message.setField(this, 7, value)
    }
    get updated_at() {
      return pb_1.Message.getFieldWithDefault(this, 8, 0) as number
    }
    set updated_at(value: number) {
      pb_1.Message.setField(this, 8, value)
    }
    static fromObject(data: {
      id?: number
      survey_id?: number
      survey_url?: string
      effected_at?: number
      expired_at?: number
      survey?: string
      created_at?: number
      updated_at?: number
    }): SurveyConf {
      const message = new SurveyConf({})
      if (data.id != null) {
        message.id = data.id
      }
      if (data.survey_id != null) {
        message.survey_id = data.survey_id
      }
      if (data.survey_url != null) {
        message.survey_url = data.survey_url
      }
      if (data.effected_at != null) {
        message.effected_at = data.effected_at
      }
      if (data.expired_at != null) {
        message.expired_at = data.expired_at
      }
      if (data.survey != null) {
        message.survey = data.survey
      }
      if (data.created_at != null) {
        message.created_at = data.created_at
      }
      if (data.updated_at != null) {
        message.updated_at = data.updated_at
      }
      return message
    }
    toObject() {
      const data: {
        id?: number
        survey_id?: number
        survey_url?: string
        effected_at?: number
        expired_at?: number
        survey?: string
        created_at?: number
        updated_at?: number
      } = {}
      if (this.id != null) {
        data.id = this.id
      }
      if (this.survey_id != null) {
        data.survey_id = this.survey_id
      }
      if (this.survey_url != null) {
        data.survey_url = this.survey_url
      }
      if (this.effected_at != null) {
        data.effected_at = this.effected_at
      }
      if (this.expired_at != null) {
        data.expired_at = this.expired_at
      }
      if (this.survey != null) {
        data.survey = this.survey
      }
      if (this.created_at != null) {
        data.created_at = this.created_at
      }
      if (this.updated_at != null) {
        data.updated_at = this.updated_at
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.id != 0) writer.writeInt64(1, this.id)
      if (this.survey_id != 0) writer.writeInt64(2, this.survey_id)
      if (this.survey_url.length) writer.writeString(3, this.survey_url)
      if (this.effected_at != 0) writer.writeInt64(4, this.effected_at)
      if (this.expired_at != 0) writer.writeInt64(5, this.expired_at)
      if (this.survey.length) writer.writeString(6, this.survey)
      if (this.created_at != 0) writer.writeInt64(7, this.created_at)
      if (this.updated_at != 0) writer.writeInt64(8, this.updated_at)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SurveyConf {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new SurveyConf()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.id = reader.readInt64()
            break
          case 2:
            message.survey_id = reader.readInt64()
            break
          case 3:
            message.survey_url = reader.readString()
            break
          case 4:
            message.effected_at = reader.readInt64()
            break
          case 5:
            message.expired_at = reader.readInt64()
            break
          case 6:
            message.survey = reader.readString()
            break
          case 7:
            message.created_at = reader.readInt64()
            break
          case 8:
            message.updated_at = reader.readInt64()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): SurveyConf {
      return SurveyConf.deserialize(bytes)
    }
  }
  export class GetSurveyResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
            data?: GetSurveyResp.RespData
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get data() {
      return pb_1.Message.getWrapperField(this, GetSurveyResp.RespData, 2) as GetSurveyResp.RespData
    }
    set data(value: GetSurveyResp.RespData) {
      pb_1.Message.setWrapperField(this, 2, value)
    }
    get has_data() {
      return pb_1.Message.getField(this, 2) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
      data?: ReturnType<typeof GetSurveyResp.RespData.prototype.toObject>
    }): GetSurveyResp {
      const message = new GetSurveyResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      if (data.data != null) {
        message.data = GetSurveyResp.RespData.fromObject(data.data)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
        data?: ReturnType<typeof GetSurveyResp.RespData.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.data != null) {
        data.data = this.data.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.has_data) writer.writeMessage(2, this.data, () => this.data.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSurveyResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new GetSurveyResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          case 2:
            reader.readMessage(
              message.data,
              () => (message.data = GetSurveyResp.RespData.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): GetSurveyResp {
      return GetSurveyResp.deserialize(bytes)
    }
  }
  export namespace GetSurveyResp {
    export class RespData extends pb_1.Message {
      #one_of_decls: number[][] = []
      constructor(
        data?:
          | any[]
          | {
              conf?: SurveyConf
              left_ts?: number
            }
      ) {
        super()
        pb_1.Message.initialize(
          this,
          Array.isArray(data) ? data : [],
          0,
          -1,
          [],
          this.#one_of_decls
        )
        if (!Array.isArray(data) && typeof data == 'object') {
          if ('conf' in data && data.conf != undefined) {
            this.conf = data.conf
          }
          if ('left_ts' in data && data.left_ts != undefined) {
            this.left_ts = data.left_ts
          }
        }
      }
      get conf() {
        return pb_1.Message.getWrapperField(this, SurveyConf, 1) as SurveyConf
      }
      set conf(value: SurveyConf) {
        pb_1.Message.setWrapperField(this, 1, value)
      }
      get has_conf() {
        return pb_1.Message.getField(this, 1) != null
      }
      get left_ts() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0) as number
      }
      set left_ts(value: number) {
        pb_1.Message.setField(this, 2, value)
      }
      static fromObject(data: {
        conf?: ReturnType<typeof SurveyConf.prototype.toObject>
        left_ts?: number
      }): RespData {
        const message = new RespData({})
        if (data.conf != null) {
          message.conf = SurveyConf.fromObject(data.conf)
        }
        if (data.left_ts != null) {
          message.left_ts = data.left_ts
        }
        return message
      }
      toObject() {
        const data: {
          conf?: ReturnType<typeof SurveyConf.prototype.toObject>
          left_ts?: number
        } = {}
        if (this.conf != null) {
          data.conf = this.conf.toObject()
        }
        if (this.left_ts != null) {
          data.left_ts = this.left_ts
        }
        return data
      }
      serialize(): Uint8Array
      serialize(w: pb_1.BinaryWriter): void
      serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter()
        if (this.has_conf) writer.writeMessage(1, this.conf, () => this.conf.serialize(writer))
        if (this.left_ts != 0) writer.writeInt64(2, this.left_ts)
        if (!w) return writer.getResultBuffer()
      }
      static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RespData {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
          message = new RespData()
        while (reader.nextField()) {
          if (reader.isEndGroup()) break
          switch (reader.getFieldNumber()) {
            case 1:
              reader.readMessage(
                message.conf,
                () => (message.conf = SurveyConf.deserialize(reader))
              )
              break
            case 2:
              message.left_ts = reader.readInt64()
              break
            default:
              reader.skipField()
          }
        }
        return message
      }
      serializeBinary(): Uint8Array {
        return this.serialize()
      }
      static deserializeBinary(bytes: Uint8Array): RespData {
        return RespData.deserialize(bytes)
      }
    }
  }

  /**
      act/survey/submit/
       **/
  export class SubmitSurveyReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
            survey_conf_id?: number
            write_time?: number
            question_content?: string
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('survey_conf_id' in data && data.survey_conf_id != undefined) {
          this.survey_conf_id = data.survey_conf_id
        }
        if ('write_time' in data && data.write_time != undefined) {
          this.write_time = data.write_time
        }
        if ('question_content' in data && data.question_content != undefined) {
          this.question_content = data.question_content
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get survey_conf_id() {
      return pb_1.Message.getFieldWithDefault(this, 2, 0) as number
    }
    set survey_conf_id(value: number) {
      pb_1.Message.setField(this, 2, value)
    }
    get write_time() {
      return pb_1.Message.getFieldWithDefault(this, 3, 0) as number
    }
    set write_time(value: number) {
      pb_1.Message.setField(this, 3, value)
    }
    get question_content() {
      return pb_1.Message.getFieldWithDefault(this, 4, '') as string
    }
    set question_content(value: string) {
      pb_1.Message.setField(this, 4, value)
    }
    static fromObject(data: {
      header?: ReturnType<typeof ReqHeader.prototype.toObject>
      survey_conf_id?: number
      write_time?: number
      question_content?: string
    }): SubmitSurveyReq {
      const message = new SubmitSurveyReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      if (data.survey_conf_id != null) {
        message.survey_conf_id = data.survey_conf_id
      }
      if (data.write_time != null) {
        message.write_time = data.write_time
      }
      if (data.question_content != null) {
        message.question_content = data.question_content
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
        survey_conf_id?: number
        write_time?: number
        question_content?: string
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.survey_conf_id != null) {
        data.survey_conf_id = this.survey_conf_id
      }
      if (this.write_time != null) {
        data.write_time = this.write_time
      }
      if (this.question_content != null) {
        data.question_content = this.question_content
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.survey_conf_id != 0) writer.writeInt64(2, this.survey_conf_id)
      if (this.write_time != 0) writer.writeInt64(3, this.write_time)
      if (this.question_content.length) writer.writeString(4, this.question_content)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubmitSurveyReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new SubmitSurveyReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          case 2:
            message.survey_conf_id = reader.readInt64()
            break
          case 3:
            message.write_time = reader.readInt64()
            break
          case 4:
            message.question_content = reader.readString()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): SubmitSurveyReq {
      return SubmitSurveyReq.deserialize(bytes)
    }
  }
  export class SubmitSurveyResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
            data?: SubmitSurveyResp.RespData
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get data() {
      return pb_1.Message.getWrapperField(
        this,
        SubmitSurveyResp.RespData,
        2
      ) as SubmitSurveyResp.RespData
    }
    set data(value: SubmitSurveyResp.RespData) {
      pb_1.Message.setWrapperField(this, 2, value)
    }
    get has_data() {
      return pb_1.Message.getField(this, 2) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
      data?: ReturnType<typeof SubmitSurveyResp.RespData.prototype.toObject>
    }): SubmitSurveyResp {
      const message = new SubmitSurveyResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      if (data.data != null) {
        message.data = SubmitSurveyResp.RespData.fromObject(data.data)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
        data?: ReturnType<typeof SubmitSurveyResp.RespData.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.data != null) {
        data.data = this.data.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.has_data) writer.writeMessage(2, this.data, () => this.data.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubmitSurveyResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new SubmitSurveyResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          case 2:
            reader.readMessage(
              message.data,
              () => (message.data = SubmitSurveyResp.RespData.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): SubmitSurveyResp {
      return SubmitSurveyResp.deserialize(bytes)
    }
  }
  export namespace SubmitSurveyResp {
    export class BonusData extends pb_1.Message {
      #one_of_decls: number[][] = []
      constructor(
        data?:
          | any[]
          | {
              props_id?: number
              props_val?: number
            }
      ) {
        super()
        pb_1.Message.initialize(
          this,
          Array.isArray(data) ? data : [],
          0,
          -1,
          [],
          this.#one_of_decls
        )
        if (!Array.isArray(data) && typeof data == 'object') {
          if ('props_id' in data && data.props_id != undefined) {
            this.props_id = data.props_id
          }
          if ('props_val' in data && data.props_val != undefined) {
            this.props_val = data.props_val
          }
        }
      }
      get props_id() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
      }
      set props_id(value: number) {
        pb_1.Message.setField(this, 1, value)
      }
      get props_val() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0) as number
      }
      set props_val(value: number) {
        pb_1.Message.setField(this, 2, value)
      }
      static fromObject(data: { props_id?: number; props_val?: number }): BonusData {
        const message = new BonusData({})
        if (data.props_id != null) {
          message.props_id = data.props_id
        }
        if (data.props_val != null) {
          message.props_val = data.props_val
        }
        return message
      }
      toObject() {
        const data: {
          props_id?: number
          props_val?: number
        } = {}
        if (this.props_id != null) {
          data.props_id = this.props_id
        }
        if (this.props_val != null) {
          data.props_val = this.props_val
        }
        return data
      }
      serialize(): Uint8Array
      serialize(w: pb_1.BinaryWriter): void
      serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter()
        if (this.props_id != 0) writer.writeInt64(1, this.props_id)
        if (this.props_val != 0) writer.writeInt64(2, this.props_val)
        if (!w) return writer.getResultBuffer()
      }
      static deserialize(bytes: Uint8Array | pb_1.BinaryReader): BonusData {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
          message = new BonusData()
        while (reader.nextField()) {
          if (reader.isEndGroup()) break
          switch (reader.getFieldNumber()) {
            case 1:
              message.props_id = reader.readInt64()
              break
            case 2:
              message.props_val = reader.readInt64()
              break
            default:
              reader.skipField()
          }
        }
        return message
      }
      serializeBinary(): Uint8Array {
        return this.serialize()
      }
      static deserializeBinary(bytes: Uint8Array): BonusData {
        return BonusData.deserialize(bytes)
      }
    }
    export class RespData extends pb_1.Message {
      #one_of_decls: number[][] = []
      constructor(
        data?:
          | any[]
          | {
              bonus_data?: SubmitSurveyResp.BonusData
            }
      ) {
        super()
        pb_1.Message.initialize(
          this,
          Array.isArray(data) ? data : [],
          0,
          -1,
          [],
          this.#one_of_decls
        )
        if (!Array.isArray(data) && typeof data == 'object') {
          if ('bonus_data' in data && data.bonus_data != undefined) {
            this.bonus_data = data.bonus_data
          }
        }
      }
      get bonus_data() {
        return pb_1.Message.getWrapperField(
          this,
          SubmitSurveyResp.BonusData,
          1
        ) as SubmitSurveyResp.BonusData
      }
      set bonus_data(value: SubmitSurveyResp.BonusData) {
        pb_1.Message.setWrapperField(this, 1, value)
      }
      get has_bonus_data() {
        return pb_1.Message.getField(this, 1) != null
      }
      static fromObject(data: {
        bonus_data?: ReturnType<typeof SubmitSurveyResp.BonusData.prototype.toObject>
      }): RespData {
        const message = new RespData({})
        if (data.bonus_data != null) {
          message.bonus_data = SubmitSurveyResp.BonusData.fromObject(data.bonus_data)
        }
        return message
      }
      toObject() {
        const data: {
          bonus_data?: ReturnType<typeof SubmitSurveyResp.BonusData.prototype.toObject>
        } = {}
        if (this.bonus_data != null) {
          data.bonus_data = this.bonus_data.toObject()
        }
        return data
      }
      serialize(): Uint8Array
      serialize(w: pb_1.BinaryWriter): void
      serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter()
        if (this.has_bonus_data)
          writer.writeMessage(1, this.bonus_data, () => this.bonus_data.serialize(writer))
        if (!w) return writer.getResultBuffer()
      }
      static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RespData {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
          message = new RespData()
        while (reader.nextField()) {
          if (reader.isEndGroup()) break
          switch (reader.getFieldNumber()) {
            case 1:
              reader.readMessage(
                message.bonus_data,
                () => (message.bonus_data = SubmitSurveyResp.BonusData.deserialize(reader))
              )
              break
            default:
              reader.skipField()
          }
        }
        return message
      }
      serializeBinary(): Uint8Array {
        return this.serialize()
      }
      static deserializeBinary(bytes: Uint8Array): RespData {
        return RespData.deserialize(bytes)
      }
    }
  }

  /**
      //// KYC
       印度版kyc
       **/
  export class InKycExtra extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            CPF_OR_CNPJ?: string
            CEP?: string
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('CPF_OR_CNPJ' in data && data.CPF_OR_CNPJ != undefined) {
          this.CPF_OR_CNPJ = data.CPF_OR_CNPJ
        }
        if ('CEP' in data && data.CEP != undefined) {
          this.CEP = data.CEP
        }
      }
    }

    /**
          长度12或者14
           **/
    get CPF_OR_CNPJ() {
      return pb_1.Message.getFieldWithDefault(this, 1, '') as string
    }

    /**
          长度12或者14
           **/
    set CPF_OR_CNPJ(value: string) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          长度8
           **/
    get CEP() {
      return pb_1.Message.getFieldWithDefault(this, 2, '') as string
    }

    /**
          长度8
           **/
    set CEP(value: string) {
      pb_1.Message.setField(this, 2, value)
    }
    static fromObject(data: { CPF_OR_CNPJ?: string; CEP?: string }): InKycExtra {
      const message = new InKycExtra({})
      if (data.CPF_OR_CNPJ != null) {
        message.CPF_OR_CNPJ = data.CPF_OR_CNPJ
      }
      if (data.CEP != null) {
        message.CEP = data.CEP
      }
      return message
    }
    toObject() {
      const data: {
        CPF_OR_CNPJ?: string
        CEP?: string
      } = {}
      if (this.CPF_OR_CNPJ != null) {
        data.CPF_OR_CNPJ = this.CPF_OR_CNPJ
      }
      if (this.CEP != null) {
        data.CEP = this.CEP
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.CPF_OR_CNPJ.length) writer.writeString(1, this.CPF_OR_CNPJ)
      if (this.CEP.length) writer.writeString(2, this.CEP)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): InKycExtra {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new InKycExtra()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.CPF_OR_CNPJ = reader.readString()
            break
          case 2:
            message.CEP = reader.readString()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): InKycExtra {
      return InKycExtra.deserialize(bytes)
    }
  }

  /**
      巴西版kyc
       **/
  export class BrKycExtra extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            CPF_OR_CNPJ?: string
            CEP?: string
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('CPF_OR_CNPJ' in data && data.CPF_OR_CNPJ != undefined) {
          this.CPF_OR_CNPJ = data.CPF_OR_CNPJ
        }
        if ('CEP' in data && data.CEP != undefined) {
          this.CEP = data.CEP
        }
      }
    }

    /**
          长度12或者14
           **/
    get CPF_OR_CNPJ() {
      return pb_1.Message.getFieldWithDefault(this, 1, '') as string
    }

    /**
          长度12或者14
           **/
    set CPF_OR_CNPJ(value: string) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          长度8
           **/
    get CEP() {
      return pb_1.Message.getFieldWithDefault(this, 2, '') as string
    }

    /**
          长度8
           **/
    set CEP(value: string) {
      pb_1.Message.setField(this, 2, value)
    }
    static fromObject(data: { CPF_OR_CNPJ?: string; CEP?: string }): BrKycExtra {
      const message = new BrKycExtra({})
      if (data.CPF_OR_CNPJ != null) {
        message.CPF_OR_CNPJ = data.CPF_OR_CNPJ
      }
      if (data.CEP != null) {
        message.CEP = data.CEP
      }
      return message
    }
    toObject() {
      const data: {
        CPF_OR_CNPJ?: string
        CEP?: string
      } = {}
      if (this.CPF_OR_CNPJ != null) {
        data.CPF_OR_CNPJ = this.CPF_OR_CNPJ
      }
      if (this.CEP != null) {
        data.CEP = this.CEP
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.CPF_OR_CNPJ.length) writer.writeString(1, this.CPF_OR_CNPJ)
      if (this.CEP.length) writer.writeString(2, this.CEP)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): BrKycExtra {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new BrKycExtra()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.CPF_OR_CNPJ = reader.readString()
            break
          case 2:
            message.CEP = reader.readString()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): BrKycExtra {
      return BrKycExtra.deserialize(bytes)
    }
  }
  export class KycExtra extends pb_1.Message {
    #one_of_decls: number[][] = [[1, 2]]
    constructor(
      data?:
        | any[]
        | ({} & (
            | {
                in_kyc_extra?: InKycExtra
                br_kyc_extra?: never
              }
            | {
                in_kyc_extra?: never
                br_kyc_extra?: BrKycExtra
              }
          ))
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('in_kyc_extra' in data && data.in_kyc_extra != undefined) {
          this.in_kyc_extra = data.in_kyc_extra
        }
        if ('br_kyc_extra' in data && data.br_kyc_extra != undefined) {
          this.br_kyc_extra = data.br_kyc_extra
        }
      }
    }
    get in_kyc_extra() {
      return pb_1.Message.getWrapperField(this, InKycExtra, 1) as InKycExtra
    }
    set in_kyc_extra(value: InKycExtra) {
      pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value)
    }
    get has_in_kyc_extra() {
      return pb_1.Message.getField(this, 1) != null
    }
    get br_kyc_extra() {
      return pb_1.Message.getWrapperField(this, BrKycExtra, 2) as BrKycExtra
    }
    set br_kyc_extra(value: BrKycExtra) {
      pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[0], value)
    }
    get has_br_kyc_extra() {
      return pb_1.Message.getField(this, 2) != null
    }
    get extra_info() {
      const cases: {
        [index: number]: 'none' | 'in_kyc_extra' | 'br_kyc_extra'
      } = {
        0: 'none',
        1: 'in_kyc_extra',
        2: 'br_kyc_extra',
      }
      return cases[pb_1.Message.computeOneofCase(this, [1, 2])]
    }
    static fromObject(data: {
      in_kyc_extra?: ReturnType<typeof InKycExtra.prototype.toObject>
      br_kyc_extra?: ReturnType<typeof BrKycExtra.prototype.toObject>
    }): KycExtra {
      const message = new KycExtra({})
      if (data.in_kyc_extra != null) {
        message.in_kyc_extra = InKycExtra.fromObject(data.in_kyc_extra)
      }
      if (data.br_kyc_extra != null) {
        message.br_kyc_extra = BrKycExtra.fromObject(data.br_kyc_extra)
      }
      return message
    }
    toObject() {
      const data: {
        in_kyc_extra?: ReturnType<typeof InKycExtra.prototype.toObject>
        br_kyc_extra?: ReturnType<typeof BrKycExtra.prototype.toObject>
      } = {}
      if (this.in_kyc_extra != null) {
        data.in_kyc_extra = this.in_kyc_extra.toObject()
      }
      if (this.br_kyc_extra != null) {
        data.br_kyc_extra = this.br_kyc_extra.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_in_kyc_extra)
        writer.writeMessage(1, this.in_kyc_extra, () => this.in_kyc_extra.serialize(writer))
      if (this.has_br_kyc_extra)
        writer.writeMessage(2, this.br_kyc_extra, () => this.br_kyc_extra.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): KycExtra {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new KycExtra()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.in_kyc_extra,
              () => (message.in_kyc_extra = InKycExtra.deserialize(reader))
            )
            break
          case 2:
            reader.readMessage(
              message.br_kyc_extra,
              () => (message.br_kyc_extra = BrKycExtra.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): KycExtra {
      return KycExtra.deserialize(bytes)
    }
  }

  /**
      user/kyc/set_kyc/
       **/
  export class SetKycReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
            name?: string
            phone?: string
            email?: string
            kyc_extra_info?: KycExtra
            pan_id?: string
            pan_pic_url?: string
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('name' in data && data.name != undefined) {
          this.name = data.name
        }
        if ('phone' in data && data.phone != undefined) {
          this.phone = data.phone
        }
        if ('email' in data && data.email != undefined) {
          this.email = data.email
        }
        if ('kyc_extra_info' in data && data.kyc_extra_info != undefined) {
          this.kyc_extra_info = data.kyc_extra_info
        }
        if ('pan_id' in data && data.pan_id != undefined) {
          this.pan_id = data.pan_id
        }
        if ('pan_pic_url' in data && data.pan_pic_url != undefined) {
          this.pan_pic_url = data.pan_pic_url
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get name() {
      return pb_1.Message.getFieldWithDefault(this, 2, '') as string
    }
    set name(value: string) {
      pb_1.Message.setField(this, 2, value)
    }
    get phone() {
      return pb_1.Message.getFieldWithDefault(this, 3, '') as string
    }
    set phone(value: string) {
      pb_1.Message.setField(this, 3, value)
    }
    get email() {
      return pb_1.Message.getFieldWithDefault(this, 4, '') as string
    }
    set email(value: string) {
      pb_1.Message.setField(this, 4, value)
    }
    get kyc_extra_info() {
      return pb_1.Message.getWrapperField(this, KycExtra, 5) as KycExtra
    }
    set kyc_extra_info(value: KycExtra) {
      pb_1.Message.setWrapperField(this, 5, value)
    }
    get has_kyc_extra_info() {
      return pb_1.Message.getField(this, 5) != null
    }
    get pan_id() {
      return pb_1.Message.getFieldWithDefault(this, 6, '') as string
    }
    set pan_id(value: string) {
      pb_1.Message.setField(this, 6, value)
    }
    get pan_pic_url() {
      return pb_1.Message.getFieldWithDefault(this, 7, '') as string
    }
    set pan_pic_url(value: string) {
      pb_1.Message.setField(this, 7, value)
    }
    static fromObject(data: {
      header?: ReturnType<typeof ReqHeader.prototype.toObject>
      name?: string
      phone?: string
      email?: string
      kyc_extra_info?: ReturnType<typeof KycExtra.prototype.toObject>
      pan_id?: string
      pan_pic_url?: string
    }): SetKycReq {
      const message = new SetKycReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      if (data.name != null) {
        message.name = data.name
      }
      if (data.phone != null) {
        message.phone = data.phone
      }
      if (data.email != null) {
        message.email = data.email
      }
      if (data.kyc_extra_info != null) {
        message.kyc_extra_info = KycExtra.fromObject(data.kyc_extra_info)
      }
      if (data.pan_id != null) {
        message.pan_id = data.pan_id
      }
      if (data.pan_pic_url != null) {
        message.pan_pic_url = data.pan_pic_url
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
        name?: string
        phone?: string
        email?: string
        kyc_extra_info?: ReturnType<typeof KycExtra.prototype.toObject>
        pan_id?: string
        pan_pic_url?: string
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.name != null) {
        data.name = this.name
      }
      if (this.phone != null) {
        data.phone = this.phone
      }
      if (this.email != null) {
        data.email = this.email
      }
      if (this.kyc_extra_info != null) {
        data.kyc_extra_info = this.kyc_extra_info.toObject()
      }
      if (this.pan_id != null) {
        data.pan_id = this.pan_id
      }
      if (this.pan_pic_url != null) {
        data.pan_pic_url = this.pan_pic_url
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.name.length) writer.writeString(2, this.name)
      if (this.phone.length) writer.writeString(3, this.phone)
      if (this.email.length) writer.writeString(4, this.email)
      if (this.has_kyc_extra_info)
        writer.writeMessage(5, this.kyc_extra_info, () => this.kyc_extra_info.serialize(writer))
      if (this.pan_id.length) writer.writeString(6, this.pan_id)
      if (this.pan_pic_url.length) writer.writeString(7, this.pan_pic_url)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SetKycReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new SetKycReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          case 2:
            message.name = reader.readString()
            break
          case 3:
            message.phone = reader.readString()
            break
          case 4:
            message.email = reader.readString()
            break
          case 5:
            reader.readMessage(
              message.kyc_extra_info,
              () => (message.kyc_extra_info = KycExtra.deserialize(reader))
            )
            break
          case 6:
            message.pan_id = reader.readString()
            break
          case 7:
            message.pan_pic_url = reader.readString()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): SetKycReq {
      return SetKycReq.deserialize(bytes)
    }
  }
  export class SetKycResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
            data?: SetKycResp.KycResp
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get data() {
      return pb_1.Message.getWrapperField(this, SetKycResp.KycResp, 2) as SetKycResp.KycResp
    }
    set data(value: SetKycResp.KycResp) {
      pb_1.Message.setWrapperField(this, 2, value)
    }
    get has_data() {
      return pb_1.Message.getField(this, 2) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
      data?: ReturnType<typeof SetKycResp.KycResp.prototype.toObject>
    }): SetKycResp {
      const message = new SetKycResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      if (data.data != null) {
        message.data = SetKycResp.KycResp.fromObject(data.data)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
        data?: ReturnType<typeof SetKycResp.KycResp.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.data != null) {
        data.data = this.data.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.has_data) writer.writeMessage(2, this.data, () => this.data.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SetKycResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new SetKycResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          case 2:
            reader.readMessage(
              message.data,
              () => (message.data = SetKycResp.KycResp.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): SetKycResp {
      return SetKycResp.deserialize(bytes)
    }
  }
  export namespace SetKycResp {
    export class KycResp extends pb_1.Message {
      #one_of_decls: number[][] = []
      constructor(
        data?:
          | any[]
          | {
              award_amount?: number
            }
      ) {
        super()
        pb_1.Message.initialize(
          this,
          Array.isArray(data) ? data : [],
          0,
          -1,
          [],
          this.#one_of_decls
        )
        if (!Array.isArray(data) && typeof data == 'object') {
          if ('award_amount' in data && data.award_amount != undefined) {
            this.award_amount = data.award_amount
          }
        }
      }
      get award_amount() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
      }
      set award_amount(value: number) {
        pb_1.Message.setField(this, 1, value)
      }
      static fromObject(data: { award_amount?: number }): KycResp {
        const message = new KycResp({})
        if (data.award_amount != null) {
          message.award_amount = data.award_amount
        }
        return message
      }
      toObject() {
        const data: {
          award_amount?: number
        } = {}
        if (this.award_amount != null) {
          data.award_amount = this.award_amount
        }
        return data
      }
      serialize(): Uint8Array
      serialize(w: pb_1.BinaryWriter): void
      serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter()
        if (this.award_amount != 0) writer.writeInt64(1, this.award_amount)
        if (!w) return writer.getResultBuffer()
      }
      static deserialize(bytes: Uint8Array | pb_1.BinaryReader): KycResp {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
          message = new KycResp()
        while (reader.nextField()) {
          if (reader.isEndGroup()) break
          switch (reader.getFieldNumber()) {
            case 1:
              message.award_amount = reader.readInt64()
              break
            default:
              reader.skipField()
          }
        }
        return message
      }
      serializeBinary(): Uint8Array {
        return this.serialize()
      }
      static deserializeBinary(bytes: Uint8Array): KycResp {
        return KycResp.deserialize(bytes)
      }
    }
  }
  export class KycData extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            name?: string
            phone?: string
            email?: string
            kyc_extra_info?: KycExtra
            pan_id?: string
            pan_pic_url?: string
            max_pan_count?: number
            today_pan_count?: number
            size_pan_file?: number
            pan_pic_key?: string
            kyc_award?: number
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('name' in data && data.name != undefined) {
          this.name = data.name
        }
        if ('phone' in data && data.phone != undefined) {
          this.phone = data.phone
        }
        if ('email' in data && data.email != undefined) {
          this.email = data.email
        }
        if ('kyc_extra_info' in data && data.kyc_extra_info != undefined) {
          this.kyc_extra_info = data.kyc_extra_info
        }
        if ('pan_id' in data && data.pan_id != undefined) {
          this.pan_id = data.pan_id
        }
        if ('pan_pic_url' in data && data.pan_pic_url != undefined) {
          this.pan_pic_url = data.pan_pic_url
        }
        if ('max_pan_count' in data && data.max_pan_count != undefined) {
          this.max_pan_count = data.max_pan_count
        }
        if ('today_pan_count' in data && data.today_pan_count != undefined) {
          this.today_pan_count = data.today_pan_count
        }
        if ('size_pan_file' in data && data.size_pan_file != undefined) {
          this.size_pan_file = data.size_pan_file
        }
        if ('pan_pic_key' in data && data.pan_pic_key != undefined) {
          this.pan_pic_key = data.pan_pic_key
        }
        if ('kyc_award' in data && data.kyc_award != undefined) {
          this.kyc_award = data.kyc_award
        }
      }
    }
    get name() {
      return pb_1.Message.getFieldWithDefault(this, 1, '') as string
    }
    set name(value: string) {
      pb_1.Message.setField(this, 1, value)
    }
    get phone() {
      return pb_1.Message.getFieldWithDefault(this, 2, '') as string
    }
    set phone(value: string) {
      pb_1.Message.setField(this, 2, value)
    }
    get email() {
      return pb_1.Message.getFieldWithDefault(this, 3, '') as string
    }
    set email(value: string) {
      pb_1.Message.setField(this, 3, value)
    }
    get kyc_extra_info() {
      return pb_1.Message.getWrapperField(this, KycExtra, 4) as KycExtra
    }
    set kyc_extra_info(value: KycExtra) {
      pb_1.Message.setWrapperField(this, 4, value)
    }
    get has_kyc_extra_info() {
      return pb_1.Message.getField(this, 4) != null
    }
    get pan_id() {
      return pb_1.Message.getFieldWithDefault(this, 5, '') as string
    }
    set pan_id(value: string) {
      pb_1.Message.setField(this, 5, value)
    }
    get pan_pic_url() {
      return pb_1.Message.getFieldWithDefault(this, 6, '') as string
    }
    set pan_pic_url(value: string) {
      pb_1.Message.setField(this, 6, value)
    }
    get max_pan_count() {
      return pb_1.Message.getFieldWithDefault(this, 7, 0) as number
    }
    set max_pan_count(value: number) {
      pb_1.Message.setField(this, 7, value)
    }
    get today_pan_count() {
      return pb_1.Message.getFieldWithDefault(this, 8, 0) as number
    }
    set today_pan_count(value: number) {
      pb_1.Message.setField(this, 8, value)
    }
    get size_pan_file() {
      return pb_1.Message.getFieldWithDefault(this, 9, 0) as number
    }
    set size_pan_file(value: number) {
      pb_1.Message.setField(this, 9, value)
    }
    get pan_pic_key() {
      return pb_1.Message.getFieldWithDefault(this, 10, '') as string
    }
    set pan_pic_key(value: string) {
      pb_1.Message.setField(this, 10, value)
    }
    get kyc_award() {
      return pb_1.Message.getFieldWithDefault(this, 11, 0) as number
    }
    set kyc_award(value: number) {
      pb_1.Message.setField(this, 11, value)
    }
    static fromObject(data: {
      name?: string
      phone?: string
      email?: string
      kyc_extra_info?: ReturnType<typeof KycExtra.prototype.toObject>
      pan_id?: string
      pan_pic_url?: string
      max_pan_count?: number
      today_pan_count?: number
      size_pan_file?: number
      pan_pic_key?: string
      kyc_award?: number
    }): KycData {
      const message = new KycData({})
      if (data.name != null) {
        message.name = data.name
      }
      if (data.phone != null) {
        message.phone = data.phone
      }
      if (data.email != null) {
        message.email = data.email
      }
      if (data.kyc_extra_info != null) {
        message.kyc_extra_info = KycExtra.fromObject(data.kyc_extra_info)
      }
      if (data.pan_id != null) {
        message.pan_id = data.pan_id
      }
      if (data.pan_pic_url != null) {
        message.pan_pic_url = data.pan_pic_url
      }
      if (data.max_pan_count != null) {
        message.max_pan_count = data.max_pan_count
      }
      if (data.today_pan_count != null) {
        message.today_pan_count = data.today_pan_count
      }
      if (data.size_pan_file != null) {
        message.size_pan_file = data.size_pan_file
      }
      if (data.pan_pic_key != null) {
        message.pan_pic_key = data.pan_pic_key
      }
      if (data.kyc_award != null) {
        message.kyc_award = data.kyc_award
      }
      return message
    }
    toObject() {
      const data: {
        name?: string
        phone?: string
        email?: string
        kyc_extra_info?: ReturnType<typeof KycExtra.prototype.toObject>
        pan_id?: string
        pan_pic_url?: string
        max_pan_count?: number
        today_pan_count?: number
        size_pan_file?: number
        pan_pic_key?: string
        kyc_award?: number
      } = {}
      if (this.name != null) {
        data.name = this.name
      }
      if (this.phone != null) {
        data.phone = this.phone
      }
      if (this.email != null) {
        data.email = this.email
      }
      if (this.kyc_extra_info != null) {
        data.kyc_extra_info = this.kyc_extra_info.toObject()
      }
      if (this.pan_id != null) {
        data.pan_id = this.pan_id
      }
      if (this.pan_pic_url != null) {
        data.pan_pic_url = this.pan_pic_url
      }
      if (this.max_pan_count != null) {
        data.max_pan_count = this.max_pan_count
      }
      if (this.today_pan_count != null) {
        data.today_pan_count = this.today_pan_count
      }
      if (this.size_pan_file != null) {
        data.size_pan_file = this.size_pan_file
      }
      if (this.pan_pic_key != null) {
        data.pan_pic_key = this.pan_pic_key
      }
      if (this.kyc_award != null) {
        data.kyc_award = this.kyc_award
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.name.length) writer.writeString(1, this.name)
      if (this.phone.length) writer.writeString(2, this.phone)
      if (this.email.length) writer.writeString(3, this.email)
      if (this.has_kyc_extra_info)
        writer.writeMessage(4, this.kyc_extra_info, () => this.kyc_extra_info.serialize(writer))
      if (this.pan_id.length) writer.writeString(5, this.pan_id)
      if (this.pan_pic_url.length) writer.writeString(6, this.pan_pic_url)
      if (this.max_pan_count != 0) writer.writeInt64(7, this.max_pan_count)
      if (this.today_pan_count != 0) writer.writeInt64(8, this.today_pan_count)
      if (this.size_pan_file != 0) writer.writeInt64(9, this.size_pan_file)
      if (this.pan_pic_key.length) writer.writeString(10, this.pan_pic_key)
      if (this.kyc_award != 0) writer.writeInt64(11, this.kyc_award)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): KycData {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new KycData()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.name = reader.readString()
            break
          case 2:
            message.phone = reader.readString()
            break
          case 3:
            message.email = reader.readString()
            break
          case 4:
            reader.readMessage(
              message.kyc_extra_info,
              () => (message.kyc_extra_info = KycExtra.deserialize(reader))
            )
            break
          case 5:
            message.pan_id = reader.readString()
            break
          case 6:
            message.pan_pic_url = reader.readString()
            break
          case 7:
            message.max_pan_count = reader.readInt64()
            break
          case 8:
            message.today_pan_count = reader.readInt64()
            break
          case 9:
            message.size_pan_file = reader.readInt64()
            break
          case 10:
            message.pan_pic_key = reader.readString()
            break
          case 11:
            message.kyc_award = reader.readInt64()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): KycData {
      return KycData.deserialize(bytes)
    }
  }

  /**
      user/kyc/get_kyc/
       **/
  export class GetKycReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof ReqHeader.prototype.toObject>
    }): GetKycReq {
      const message = new GetKycReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetKycReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new GetKycReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): GetKycReq {
      return GetKycReq.deserialize(bytes)
    }
  }
  export class GetKycResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
            data?: KycData
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get data() {
      return pb_1.Message.getWrapperField(this, KycData, 2) as KycData
    }
    set data(value: KycData) {
      pb_1.Message.setWrapperField(this, 2, value)
    }
    get has_data() {
      return pb_1.Message.getField(this, 2) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
      data?: ReturnType<typeof KycData.prototype.toObject>
    }): GetKycResp {
      const message = new GetKycResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      if (data.data != null) {
        message.data = KycData.fromObject(data.data)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
        data?: ReturnType<typeof KycData.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.data != null) {
        data.data = this.data.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.has_data) writer.writeMessage(2, this.data, () => this.data.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetKycResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new GetKycResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          case 2:
            reader.readMessage(message.data, () => (message.data = KycData.deserialize(reader)))
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): GetKycResp {
      return GetKycResp.deserialize(bytes)
    }
  }

  /**
      user/kyc/get_kyc_pre_url/
       **/
  export class GetKycPreUrlReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
            pan_id?: string
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('pan_id' in data && data.pan_id != undefined) {
          this.pan_id = data.pan_id
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get pan_id() {
      return pb_1.Message.getFieldWithDefault(this, 2, '') as string
    }
    set pan_id(value: string) {
      pb_1.Message.setField(this, 2, value)
    }
    static fromObject(data: {
      header?: ReturnType<typeof ReqHeader.prototype.toObject>
      pan_id?: string
    }): GetKycPreUrlReq {
      const message = new GetKycPreUrlReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      if (data.pan_id != null) {
        message.pan_id = data.pan_id
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
        pan_id?: string
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.pan_id != null) {
        data.pan_id = this.pan_id
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.pan_id.length) writer.writeString(2, this.pan_id)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetKycPreUrlReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new GetKycPreUrlReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          case 2:
            message.pan_id = reader.readString()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): GetKycPreUrlReq {
      return GetKycPreUrlReq.deserialize(bytes)
    }
  }
  export class GetKycPreUrlResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
            data?: GetKycPreUrlResp.UrlData
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get data() {
      return pb_1.Message.getWrapperField(
        this,
        GetKycPreUrlResp.UrlData,
        2
      ) as GetKycPreUrlResp.UrlData
    }
    set data(value: GetKycPreUrlResp.UrlData) {
      pb_1.Message.setWrapperField(this, 2, value)
    }
    get has_data() {
      return pb_1.Message.getField(this, 2) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
      data?: ReturnType<typeof GetKycPreUrlResp.UrlData.prototype.toObject>
    }): GetKycPreUrlResp {
      const message = new GetKycPreUrlResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      if (data.data != null) {
        message.data = GetKycPreUrlResp.UrlData.fromObject(data.data)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
        data?: ReturnType<typeof GetKycPreUrlResp.UrlData.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.data != null) {
        data.data = this.data.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.has_data) writer.writeMessage(2, this.data, () => this.data.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetKycPreUrlResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new GetKycPreUrlResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          case 2:
            reader.readMessage(
              message.data,
              () => (message.data = GetKycPreUrlResp.UrlData.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): GetKycPreUrlResp {
      return GetKycPreUrlResp.deserialize(bytes)
    }
  }
  export namespace GetKycPreUrlResp {
    export class UrlData extends pb_1.Message {
      #one_of_decls: number[][] = []
      constructor(
        data?:
          | any[]
          | {
              url?: string
              key?: string
              download_url?: string
            }
      ) {
        super()
        pb_1.Message.initialize(
          this,
          Array.isArray(data) ? data : [],
          0,
          -1,
          [],
          this.#one_of_decls
        )
        if (!Array.isArray(data) && typeof data == 'object') {
          if ('url' in data && data.url != undefined) {
            this.url = data.url
          }
          if ('key' in data && data.key != undefined) {
            this.key = data.key
          }
          if ('download_url' in data && data.download_url != undefined) {
            this.download_url = data.download_url
          }
        }
      }
      get url() {
        return pb_1.Message.getFieldWithDefault(this, 1, '') as string
      }
      set url(value: string) {
        pb_1.Message.setField(this, 1, value)
      }
      get key() {
        return pb_1.Message.getFieldWithDefault(this, 2, '') as string
      }
      set key(value: string) {
        pb_1.Message.setField(this, 2, value)
      }
      get download_url() {
        return pb_1.Message.getFieldWithDefault(this, 3, '') as string
      }
      set download_url(value: string) {
        pb_1.Message.setField(this, 3, value)
      }
      static fromObject(data: { url?: string; key?: string; download_url?: string }): UrlData {
        const message = new UrlData({})
        if (data.url != null) {
          message.url = data.url
        }
        if (data.key != null) {
          message.key = data.key
        }
        if (data.download_url != null) {
          message.download_url = data.download_url
        }
        return message
      }
      toObject() {
        const data: {
          url?: string
          key?: string
          download_url?: string
        } = {}
        if (this.url != null) {
          data.url = this.url
        }
        if (this.key != null) {
          data.key = this.key
        }
        if (this.download_url != null) {
          data.download_url = this.download_url
        }
        return data
      }
      serialize(): Uint8Array
      serialize(w: pb_1.BinaryWriter): void
      serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter()
        if (this.url.length) writer.writeString(1, this.url)
        if (this.key.length) writer.writeString(2, this.key)
        if (this.download_url.length) writer.writeString(3, this.download_url)
        if (!w) return writer.getResultBuffer()
      }
      static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UrlData {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
          message = new UrlData()
        while (reader.nextField()) {
          if (reader.isEndGroup()) break
          switch (reader.getFieldNumber()) {
            case 1:
              message.url = reader.readString()
              break
            case 2:
              message.key = reader.readString()
              break
            case 3:
              message.download_url = reader.readString()
              break
            default:
              reader.skipField()
          }
        }
        return message
      }
      serializeBinary(): Uint8Array {
        return this.serialize()
      }
      static deserializeBinary(bytes: Uint8Array): UrlData {
        return UrlData.deserialize(bytes)
      }
    }
  }

  /**
      PIX账号信息
       **/
  export class WithdrawAccountPix extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            pix_account_type?: PixAccountType
            pix_identity?: string
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('pix_account_type' in data && data.pix_account_type != undefined) {
          this.pix_account_type = data.pix_account_type
        }
        if ('pix_identity' in data && data.pix_identity != undefined) {
          this.pix_identity = data.pix_identity
        }
      }
    }

    /**
          PIX账号类型
           **/
    get pix_account_type() {
      return pb_1.Message.getFieldWithDefault(this, 1, PixAccountType.PIX_UNKNOWN) as PixAccountType
    }

    /**
          PIX账号类型
           **/
    set pix_account_type(value: PixAccountType) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          PIX身份验证 CPF/CNPJ
           **/
    get pix_identity() {
      return pb_1.Message.getFieldWithDefault(this, 2, '') as string
    }

    /**
          PIX身份验证 CPF/CNPJ
           **/
    set pix_identity(value: string) {
      pb_1.Message.setField(this, 2, value)
    }
    static fromObject(data: {
      pix_account_type?: PixAccountType
      pix_identity?: string
    }): WithdrawAccountPix {
      const message = new WithdrawAccountPix({})
      if (data.pix_account_type != null) {
        message.pix_account_type = data.pix_account_type
      }
      if (data.pix_identity != null) {
        message.pix_identity = data.pix_identity
      }
      return message
    }
    toObject() {
      const data: {
        pix_account_type?: PixAccountType
        pix_identity?: string
      } = {}
      if (this.pix_account_type != null) {
        data.pix_account_type = this.pix_account_type
      }
      if (this.pix_identity != null) {
        data.pix_identity = this.pix_identity
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.pix_account_type != PixAccountType.PIX_UNKNOWN)
        writer.writeEnum(1, this.pix_account_type)
      if (this.pix_identity.length) writer.writeString(2, this.pix_identity)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WithdrawAccountPix {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new WithdrawAccountPix()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.pix_account_type = reader.readEnum()
            break
          case 2:
            message.pix_identity = reader.readString()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): WithdrawAccountPix {
      return WithdrawAccountPix.deserialize(bytes)
    }
  }

  /**
      银行账号信息
       **/
  export class WithdrawAccountBank extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            ifsc?: string
            bank_code?: string
            bank_branch?: string
            address?: string
            phone?: string
            email?: string
            bank_name?: string
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('ifsc' in data && data.ifsc != undefined) {
          this.ifsc = data.ifsc
        }
        if ('bank_code' in data && data.bank_code != undefined) {
          this.bank_code = data.bank_code
        }
        if ('bank_branch' in data && data.bank_branch != undefined) {
          this.bank_branch = data.bank_branch
        }
        if ('address' in data && data.address != undefined) {
          this.address = data.address
        }
        if ('phone' in data && data.phone != undefined) {
          this.phone = data.phone
        }
        if ('email' in data && data.email != undefined) {
          this.email = data.email
        }
        if ('bank_name' in data && data.bank_name != undefined) {
          this.bank_name = data.bank_name
        }
      }
    }

    /**
          IFSC code
           **/
    get ifsc() {
      return pb_1.Message.getFieldWithDefault(this, 1, '') as string
    }

    /**
          IFSC code
           **/
    set ifsc(value: string) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          银行代码
           **/
    get bank_code() {
      return pb_1.Message.getFieldWithDefault(this, 2, '') as string
    }

    /**
          银行代码
           **/
    set bank_code(value: string) {
      pb_1.Message.setField(this, 2, value)
    }

    /**
          银行支行
           **/
    get bank_branch() {
      return pb_1.Message.getFieldWithDefault(this, 3, '') as string
    }

    /**
          银行支行
           **/
    set bank_branch(value: string) {
      pb_1.Message.setField(this, 3, value)
    }

    /**
          用户地址
           **/
    get address() {
      return pb_1.Message.getFieldWithDefault(this, 4, '') as string
    }

    /**
          用户地址
           **/
    set address(value: string) {
      pb_1.Message.setField(this, 4, value)
    }

    /**
          用户手机号
           **/
    get phone() {
      return pb_1.Message.getFieldWithDefault(this, 5, '') as string
    }

    /**
          用户手机号
           **/
    set phone(value: string) {
      pb_1.Message.setField(this, 5, value)
    }

    /**
          用户邮箱
           **/
    get email() {
      return pb_1.Message.getFieldWithDefault(this, 6, '') as string
    }

    /**
          用户邮箱
           **/
    set email(value: string) {
      pb_1.Message.setField(this, 6, value)
    }

    /**
          银行名称
           **/
    get bank_name() {
      return pb_1.Message.getFieldWithDefault(this, 7, '') as string
    }

    /**
          银行名称
           **/
    set bank_name(value: string) {
      pb_1.Message.setField(this, 7, value)
    }
    static fromObject(data: {
      ifsc?: string
      bank_code?: string
      bank_branch?: string
      address?: string
      phone?: string
      email?: string
      bank_name?: string
    }): WithdrawAccountBank {
      const message = new WithdrawAccountBank({})
      if (data.ifsc != null) {
        message.ifsc = data.ifsc
      }
      if (data.bank_code != null) {
        message.bank_code = data.bank_code
      }
      if (data.bank_branch != null) {
        message.bank_branch = data.bank_branch
      }
      if (data.address != null) {
        message.address = data.address
      }
      if (data.phone != null) {
        message.phone = data.phone
      }
      if (data.email != null) {
        message.email = data.email
      }
      if (data.bank_name != null) {
        message.bank_name = data.bank_name
      }
      return message
    }
    toObject() {
      const data: {
        ifsc?: string
        bank_code?: string
        bank_branch?: string
        address?: string
        phone?: string
        email?: string
        bank_name?: string
      } = {}
      if (this.ifsc != null) {
        data.ifsc = this.ifsc
      }
      if (this.bank_code != null) {
        data.bank_code = this.bank_code
      }
      if (this.bank_branch != null) {
        data.bank_branch = this.bank_branch
      }
      if (this.address != null) {
        data.address = this.address
      }
      if (this.phone != null) {
        data.phone = this.phone
      }
      if (this.email != null) {
        data.email = this.email
      }
      if (this.bank_name != null) {
        data.bank_name = this.bank_name
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.ifsc.length) writer.writeString(1, this.ifsc)
      if (this.bank_code.length) writer.writeString(2, this.bank_code)
      if (this.bank_branch.length) writer.writeString(3, this.bank_branch)
      if (this.address.length) writer.writeString(4, this.address)
      if (this.phone.length) writer.writeString(5, this.phone)
      if (this.email.length) writer.writeString(6, this.email)
      if (this.bank_name.length) writer.writeString(7, this.bank_name)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WithdrawAccountBank {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new WithdrawAccountBank()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.ifsc = reader.readString()
            break
          case 2:
            message.bank_code = reader.readString()
            break
          case 3:
            message.bank_branch = reader.readString()
            break
          case 4:
            message.address = reader.readString()
            break
          case 5:
            message.phone = reader.readString()
            break
          case 6:
            message.email = reader.readString()
            break
          case 7:
            message.bank_name = reader.readString()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): WithdrawAccountBank {
      return WithdrawAccountBank.deserialize(bytes)
    }
  }

  /**
      UPI账号信息
       **/
  export class WithdrawAccountUpi extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            address?: string
            phone?: string
            email?: string
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('address' in data && data.address != undefined) {
          this.address = data.address
        }
        if ('phone' in data && data.phone != undefined) {
          this.phone = data.phone
        }
        if ('email' in data && data.email != undefined) {
          this.email = data.email
        }
      }
    }

    /**
          用户地址
           **/
    get address() {
      return pb_1.Message.getFieldWithDefault(this, 1, '') as string
    }

    /**
          用户地址
           **/
    set address(value: string) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          用户手机号
           **/
    get phone() {
      return pb_1.Message.getFieldWithDefault(this, 2, '') as string
    }

    /**
          用户手机号
           **/
    set phone(value: string) {
      pb_1.Message.setField(this, 2, value)
    }

    /**
          用户邮箱
           **/
    get email() {
      return pb_1.Message.getFieldWithDefault(this, 3, '') as string
    }

    /**
          用户邮箱
           **/
    set email(value: string) {
      pb_1.Message.setField(this, 3, value)
    }
    static fromObject(data: {
      address?: string
      phone?: string
      email?: string
    }): WithdrawAccountUpi {
      const message = new WithdrawAccountUpi({})
      if (data.address != null) {
        message.address = data.address
      }
      if (data.phone != null) {
        message.phone = data.phone
      }
      if (data.email != null) {
        message.email = data.email
      }
      return message
    }
    toObject() {
      const data: {
        address?: string
        phone?: string
        email?: string
      } = {}
      if (this.address != null) {
        data.address = this.address
      }
      if (this.phone != null) {
        data.phone = this.phone
      }
      if (this.email != null) {
        data.email = this.email
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.address.length) writer.writeString(1, this.address)
      if (this.phone.length) writer.writeString(2, this.phone)
      if (this.email.length) writer.writeString(3, this.email)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WithdrawAccountUpi {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new WithdrawAccountUpi()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.address = reader.readString()
            break
          case 2:
            message.phone = reader.readString()
            break
          case 3:
            message.email = reader.readString()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): WithdrawAccountUpi {
      return WithdrawAccountUpi.deserialize(bytes)
    }
  }

  /**
      电子钱包账号信息
       **/
  export class WithdrawAccountEWallet extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            ewallet_type?: WithdrawAccountType
            ewallet_name?: string
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('ewallet_type' in data && data.ewallet_type != undefined) {
          this.ewallet_type = data.ewallet_type
        }
        if ('ewallet_name' in data && data.ewallet_name != undefined) {
          this.ewallet_name = data.ewallet_name
        }
      }
    }

    /**
          电子钱包类型
           **/
    get ewallet_type() {
      return pb_1.Message.getFieldWithDefault(
        this,
        1,
        WithdrawAccountType.UNKNOWN
      ) as WithdrawAccountType
    }

    /**
          电子钱包类型
           **/
    set ewallet_type(value: WithdrawAccountType) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          电子钱包名称
           **/
    get ewallet_name() {
      return pb_1.Message.getFieldWithDefault(this, 2, '') as string
    }

    /**
          电子钱包名称
           **/
    set ewallet_name(value: string) {
      pb_1.Message.setField(this, 2, value)
    }
    static fromObject(data: {
      ewallet_type?: WithdrawAccountType
      ewallet_name?: string
    }): WithdrawAccountEWallet {
      const message = new WithdrawAccountEWallet({})
      if (data.ewallet_type != null) {
        message.ewallet_type = data.ewallet_type
      }
      if (data.ewallet_name != null) {
        message.ewallet_name = data.ewallet_name
      }
      return message
    }
    toObject() {
      const data: {
        ewallet_type?: WithdrawAccountType
        ewallet_name?: string
      } = {}
      if (this.ewallet_type != null) {
        data.ewallet_type = this.ewallet_type
      }
      if (this.ewallet_name != null) {
        data.ewallet_name = this.ewallet_name
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.ewallet_type != WithdrawAccountType.UNKNOWN) writer.writeEnum(1, this.ewallet_type)
      if (this.ewallet_name.length) writer.writeString(2, this.ewallet_name)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WithdrawAccountEWallet {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new WithdrawAccountEWallet()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.ewallet_type = reader.readEnum()
            break
          case 2:
            message.ewallet_name = reader.readString()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): WithdrawAccountEWallet {
      return WithdrawAccountEWallet.deserialize(bytes)
    }
  }

  /**
      提现账号信息
       **/
  export class WithdrawAccount extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            id?: string
            type?: WithdrawAccountType
            account_no?: string
            account_name?: string
            is_default?: boolean
            pix?: WithdrawAccountPix
            bank?: WithdrawAccountBank
            upi?: WithdrawAccountUpi
            ewallet?: WithdrawAccountEWallet
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('id' in data && data.id != undefined) {
          this.id = data.id
        }
        if ('type' in data && data.type != undefined) {
          this.type = data.type
        }
        if ('account_no' in data && data.account_no != undefined) {
          this.account_no = data.account_no
        }
        if ('account_name' in data && data.account_name != undefined) {
          this.account_name = data.account_name
        }
        if ('is_default' in data && data.is_default != undefined) {
          this.is_default = data.is_default
        }
        if ('pix' in data && data.pix != undefined) {
          this.pix = data.pix
        }
        if ('bank' in data && data.bank != undefined) {
          this.bank = data.bank
        }
        if ('upi' in data && data.upi != undefined) {
          this.upi = data.upi
        }
        if ('ewallet' in data && data.ewallet != undefined) {
          this.ewallet = data.ewallet
        }
      }
    }

    /**
          账号id
           **/
    get id() {
      return pb_1.Message.getFieldWithDefault(this, 1, '') as string
    }

    /**
          账号id
           **/
    set id(value: string) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          账号类型
           **/
    get type() {
      return pb_1.Message.getFieldWithDefault(
        this,
        2,
        WithdrawAccountType.UNKNOWN
      ) as WithdrawAccountType
    }

    /**
          账号类型
           **/
    set type(value: WithdrawAccountType) {
      pb_1.Message.setField(this, 2, value)
    }

    /**
          账号
           **/
    get account_no() {
      return pb_1.Message.getFieldWithDefault(this, 3, '') as string
    }

    /**
          账号
           **/
    set account_no(value: string) {
      pb_1.Message.setField(this, 3, value)
    }

    /**
          姓名
           **/
    get account_name() {
      return pb_1.Message.getFieldWithDefault(this, 4, '') as string
    }

    /**
          姓名
           **/
    set account_name(value: string) {
      pb_1.Message.setField(this, 4, value)
    }

    /**
          是否是默认账号
           **/
    get is_default() {
      return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean
    }

    /**
          是否是默认账号
           **/
    set is_default(value: boolean) {
      pb_1.Message.setField(this, 5, value)
    }

    /**
          PIX账号信息
           **/
    get pix() {
      return pb_1.Message.getWrapperField(this, WithdrawAccountPix, 6) as WithdrawAccountPix
    }

    /**
          PIX账号信息
           **/
    set pix(value: WithdrawAccountPix) {
      pb_1.Message.setWrapperField(this, 6, value)
    }
    get has_pix() {
      return pb_1.Message.getField(this, 6) != null
    }

    /**
          银行账号信息
           **/
    get bank() {
      return pb_1.Message.getWrapperField(this, WithdrawAccountBank, 7) as WithdrawAccountBank
    }

    /**
          银行账号信息
           **/
    set bank(value: WithdrawAccountBank) {
      pb_1.Message.setWrapperField(this, 7, value)
    }
    get has_bank() {
      return pb_1.Message.getField(this, 7) != null
    }

    /**
          UPI账号信息
           **/
    get upi() {
      return pb_1.Message.getWrapperField(this, WithdrawAccountUpi, 8) as WithdrawAccountUpi
    }

    /**
          UPI账号信息
           **/
    set upi(value: WithdrawAccountUpi) {
      pb_1.Message.setWrapperField(this, 8, value)
    }
    get has_upi() {
      return pb_1.Message.getField(this, 8) != null
    }

    /**
          电子钱包账号信息
           **/
    get ewallet() {
      return pb_1.Message.getWrapperField(this, WithdrawAccountEWallet, 9) as WithdrawAccountEWallet
    }

    /**
          电子钱包账号信息
           **/
    set ewallet(value: WithdrawAccountEWallet) {
      pb_1.Message.setWrapperField(this, 9, value)
    }
    get has_ewallet() {
      return pb_1.Message.getField(this, 9) != null
    }
    static fromObject(data: {
      id?: string
      type?: WithdrawAccountType
      account_no?: string
      account_name?: string
      is_default?: boolean
      pix?: ReturnType<typeof WithdrawAccountPix.prototype.toObject>
      bank?: ReturnType<typeof WithdrawAccountBank.prototype.toObject>
      upi?: ReturnType<typeof WithdrawAccountUpi.prototype.toObject>
      ewallet?: ReturnType<typeof WithdrawAccountEWallet.prototype.toObject>
    }): WithdrawAccount {
      const message = new WithdrawAccount({})
      if (data.id != null) {
        message.id = data.id
      }
      if (data.type != null) {
        message.type = data.type
      }
      if (data.account_no != null) {
        message.account_no = data.account_no
      }
      if (data.account_name != null) {
        message.account_name = data.account_name
      }
      if (data.is_default != null) {
        message.is_default = data.is_default
      }
      if (data.pix != null) {
        message.pix = WithdrawAccountPix.fromObject(data.pix)
      }
      if (data.bank != null) {
        message.bank = WithdrawAccountBank.fromObject(data.bank)
      }
      if (data.upi != null) {
        message.upi = WithdrawAccountUpi.fromObject(data.upi)
      }
      if (data.ewallet != null) {
        message.ewallet = WithdrawAccountEWallet.fromObject(data.ewallet)
      }
      return message
    }
    toObject() {
      const data: {
        id?: string
        type?: WithdrawAccountType
        account_no?: string
        account_name?: string
        is_default?: boolean
        pix?: ReturnType<typeof WithdrawAccountPix.prototype.toObject>
        bank?: ReturnType<typeof WithdrawAccountBank.prototype.toObject>
        upi?: ReturnType<typeof WithdrawAccountUpi.prototype.toObject>
        ewallet?: ReturnType<typeof WithdrawAccountEWallet.prototype.toObject>
      } = {}
      if (this.id != null) {
        data.id = this.id
      }
      if (this.type != null) {
        data.type = this.type
      }
      if (this.account_no != null) {
        data.account_no = this.account_no
      }
      if (this.account_name != null) {
        data.account_name = this.account_name
      }
      if (this.is_default != null) {
        data.is_default = this.is_default
      }
      if (this.pix != null) {
        data.pix = this.pix.toObject()
      }
      if (this.bank != null) {
        data.bank = this.bank.toObject()
      }
      if (this.upi != null) {
        data.upi = this.upi.toObject()
      }
      if (this.ewallet != null) {
        data.ewallet = this.ewallet.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.id.length) writer.writeString(1, this.id)
      if (this.type != WithdrawAccountType.UNKNOWN) writer.writeEnum(2, this.type)
      if (this.account_no.length) writer.writeString(3, this.account_no)
      if (this.account_name.length) writer.writeString(4, this.account_name)
      if (this.is_default != false) writer.writeBool(5, this.is_default)
      if (this.has_pix) writer.writeMessage(6, this.pix, () => this.pix.serialize(writer))
      if (this.has_bank) writer.writeMessage(7, this.bank, () => this.bank.serialize(writer))
      if (this.has_upi) writer.writeMessage(8, this.upi, () => this.upi.serialize(writer))
      if (this.has_ewallet)
        writer.writeMessage(9, this.ewallet, () => this.ewallet.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WithdrawAccount {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new WithdrawAccount()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.id = reader.readString()
            break
          case 2:
            message.type = reader.readEnum()
            break
          case 3:
            message.account_no = reader.readString()
            break
          case 4:
            message.account_name = reader.readString()
            break
          case 5:
            message.is_default = reader.readBool()
            break
          case 6:
            reader.readMessage(
              message.pix,
              () => (message.pix = WithdrawAccountPix.deserialize(reader))
            )
            break
          case 7:
            reader.readMessage(
              message.bank,
              () => (message.bank = WithdrawAccountBank.deserialize(reader))
            )
            break
          case 8:
            reader.readMessage(
              message.upi,
              () => (message.upi = WithdrawAccountUpi.deserialize(reader))
            )
            break
          case 9:
            reader.readMessage(
              message.ewallet,
              () => (message.ewallet = WithdrawAccountEWallet.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): WithdrawAccount {
      return WithdrawAccount.deserialize(bytes)
    }
  }

  /**
      pay/get_pay_info/
       获取支付信息
       **/
  export class GetPayInfoReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
            order_id?: number
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('order_id' in data && data.order_id != undefined) {
          this.order_id = data.order_id
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get order_id() {
      return pb_1.Message.getFieldWithDefault(this, 2, 0) as number
    }
    set order_id(value: number) {
      pb_1.Message.setField(this, 2, value)
    }
    static fromObject(data: {
      header?: ReturnType<typeof ReqHeader.prototype.toObject>
      order_id?: number
    }): GetPayInfoReq {
      const message = new GetPayInfoReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      if (data.order_id != null) {
        message.order_id = data.order_id
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
        order_id?: number
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.order_id != null) {
        data.order_id = this.order_id
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.order_id != 0) writer.writeInt64(2, this.order_id)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetPayInfoReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new GetPayInfoReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          case 2:
            message.order_id = reader.readInt64()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): GetPayInfoReq {
      return GetPayInfoReq.deserialize(bytes)
    }
  }
  export class GetPayInfoResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
            data?: GetPayInfoResp.RespData
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get data() {
      return pb_1.Message.getWrapperField(
        this,
        GetPayInfoResp.RespData,
        2
      ) as GetPayInfoResp.RespData
    }
    set data(value: GetPayInfoResp.RespData) {
      pb_1.Message.setWrapperField(this, 2, value)
    }
    get has_data() {
      return pb_1.Message.getField(this, 2) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
      data?: ReturnType<typeof GetPayInfoResp.RespData.prototype.toObject>
    }): GetPayInfoResp {
      const message = new GetPayInfoResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      if (data.data != null) {
        message.data = GetPayInfoResp.RespData.fromObject(data.data)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
        data?: ReturnType<typeof GetPayInfoResp.RespData.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.data != null) {
        data.data = this.data.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.has_data) writer.writeMessage(2, this.data, () => this.data.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetPayInfoResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new GetPayInfoResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          case 2:
            reader.readMessage(
              message.data,
              () => (message.data = GetPayInfoResp.RespData.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): GetPayInfoResp {
      return GetPayInfoResp.deserialize(bytes)
    }
  }
  export namespace GetPayInfoResp {
    export class RespData extends pb_1.Message {
      #one_of_decls: number[][] = []
      constructor(
        data?:
          | any[]
          | {
              withdraw_account?: WithdrawAccount
              payment_timeout_at?: number
              pay_amount?: number
            }
      ) {
        super()
        pb_1.Message.initialize(
          this,
          Array.isArray(data) ? data : [],
          0,
          -1,
          [],
          this.#one_of_decls
        )
        if (!Array.isArray(data) && typeof data == 'object') {
          if ('withdraw_account' in data && data.withdraw_account != undefined) {
            this.withdraw_account = data.withdraw_account
          }
          if ('payment_timeout_at' in data && data.payment_timeout_at != undefined) {
            this.payment_timeout_at = data.payment_timeout_at
          }
          if ('pay_amount' in data && data.pay_amount != undefined) {
            this.pay_amount = data.pay_amount
          }
        }
      }

      /**
              提现账号信息
               **/
      get withdraw_account() {
        return pb_1.Message.getWrapperField(this, WithdrawAccount, 1) as WithdrawAccount
      }

      /**
              提现账号信息
               **/
      set withdraw_account(value: WithdrawAccount) {
        pb_1.Message.setWrapperField(this, 1, value)
      }
      get has_withdraw_account() {
        return pb_1.Message.getField(this, 1) != null
      }

      /**
              支付超时时间
               **/
      get payment_timeout_at() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0) as number
      }

      /**
              支付超时时间
               **/
      set payment_timeout_at(value: number) {
        pb_1.Message.setField(this, 2, value)
      }

      /**
              支付金额
               **/
      get pay_amount() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0) as number
      }

      /**
              支付金额
               **/
      set pay_amount(value: number) {
        pb_1.Message.setField(this, 3, value)
      }
      static fromObject(data: {
        withdraw_account?: ReturnType<typeof WithdrawAccount.prototype.toObject>
        payment_timeout_at?: number
        pay_amount?: number
      }): RespData {
        const message = new RespData({})
        if (data.withdraw_account != null) {
          message.withdraw_account = WithdrawAccount.fromObject(data.withdraw_account)
        }
        if (data.payment_timeout_at != null) {
          message.payment_timeout_at = data.payment_timeout_at
        }
        if (data.pay_amount != null) {
          message.pay_amount = data.pay_amount
        }
        return message
      }
      toObject() {
        const data: {
          withdraw_account?: ReturnType<typeof WithdrawAccount.prototype.toObject>
          payment_timeout_at?: number
          pay_amount?: number
        } = {}
        if (this.withdraw_account != null) {
          data.withdraw_account = this.withdraw_account.toObject()
        }
        if (this.payment_timeout_at != null) {
          data.payment_timeout_at = this.payment_timeout_at
        }
        if (this.pay_amount != null) {
          data.pay_amount = this.pay_amount
        }
        return data
      }
      serialize(): Uint8Array
      serialize(w: pb_1.BinaryWriter): void
      serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter()
        if (this.has_withdraw_account)
          writer.writeMessage(1, this.withdraw_account, () =>
            this.withdraw_account.serialize(writer)
          )
        if (this.payment_timeout_at != 0) writer.writeInt64(2, this.payment_timeout_at)
        if (this.pay_amount != 0) writer.writeInt64(3, this.pay_amount)
        if (!w) return writer.getResultBuffer()
      }
      static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RespData {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
          message = new RespData()
        while (reader.nextField()) {
          if (reader.isEndGroup()) break
          switch (reader.getFieldNumber()) {
            case 1:
              reader.readMessage(
                message.withdraw_account,
                () => (message.withdraw_account = WithdrawAccount.deserialize(reader))
              )
              break
            case 2:
              message.payment_timeout_at = reader.readInt64()
              break
            case 3:
              message.pay_amount = reader.readInt64()
              break
            default:
              reader.skipField()
          }
        }
        return message
      }
      serializeBinary(): Uint8Array {
        return this.serialize()
      }
      static deserializeBinary(bytes: Uint8Array): RespData {
        return RespData.deserialize(bytes)
      }
    }
  }

  /**
      pay/submit_payment_voucher/
       提交支付凭证
       **/
  export class SubmitPaymentVoucherReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
            order_id?: number
            payment_voucher?: string
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('order_id' in data && data.order_id != undefined) {
          this.order_id = data.order_id
        }
        if ('payment_voucher' in data && data.payment_voucher != undefined) {
          this.payment_voucher = data.payment_voucher
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get order_id() {
      return pb_1.Message.getFieldWithDefault(this, 2, 0) as number
    }
    set order_id(value: number) {
      pb_1.Message.setField(this, 2, value)
    }

    /**
          支付凭证
           **/
    get payment_voucher() {
      return pb_1.Message.getFieldWithDefault(this, 3, '') as string
    }

    /**
          支付凭证
           **/
    set payment_voucher(value: string) {
      pb_1.Message.setField(this, 3, value)
    }
    static fromObject(data: {
      header?: ReturnType<typeof ReqHeader.prototype.toObject>
      order_id?: number
      payment_voucher?: string
    }): SubmitPaymentVoucherReq {
      const message = new SubmitPaymentVoucherReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      if (data.order_id != null) {
        message.order_id = data.order_id
      }
      if (data.payment_voucher != null) {
        message.payment_voucher = data.payment_voucher
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
        order_id?: number
        payment_voucher?: string
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.order_id != null) {
        data.order_id = this.order_id
      }
      if (this.payment_voucher != null) {
        data.payment_voucher = this.payment_voucher
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.order_id != 0) writer.writeInt64(2, this.order_id)
      if (this.payment_voucher.length) writer.writeString(3, this.payment_voucher)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubmitPaymentVoucherReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new SubmitPaymentVoucherReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          case 2:
            message.order_id = reader.readInt64()
            break
          case 3:
            message.payment_voucher = reader.readString()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): SubmitPaymentVoucherReq {
      return SubmitPaymentVoucherReq.deserialize(bytes)
    }
  }
  export class SubmitPaymentVoucherResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
    }): SubmitPaymentVoucherResp {
      const message = new SubmitPaymentVoucherResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubmitPaymentVoucherResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new SubmitPaymentVoucherResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): SubmitPaymentVoucherResp {
      return SubmitPaymentVoucherResp.deserialize(bytes)
    }
  }

  /**
      pay/get_payment_voucher_pre_url/
       获取支付凭证上传的预提交 url
       **/
  export class GetPaymentVoucherPreUrlReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
            order_id?: number
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('order_id' in data && data.order_id != undefined) {
          this.order_id = data.order_id
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get order_id() {
      return pb_1.Message.getFieldWithDefault(this, 2, 0) as number
    }
    set order_id(value: number) {
      pb_1.Message.setField(this, 2, value)
    }
    static fromObject(data: {
      header?: ReturnType<typeof ReqHeader.prototype.toObject>
      order_id?: number
    }): GetPaymentVoucherPreUrlReq {
      const message = new GetPaymentVoucherPreUrlReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      if (data.order_id != null) {
        message.order_id = data.order_id
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
        order_id?: number
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.order_id != null) {
        data.order_id = this.order_id
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.order_id != 0) writer.writeInt64(2, this.order_id)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetPaymentVoucherPreUrlReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new GetPaymentVoucherPreUrlReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          case 2:
            message.order_id = reader.readInt64()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): GetPaymentVoucherPreUrlReq {
      return GetPaymentVoucherPreUrlReq.deserialize(bytes)
    }
  }
  export class GetPaymentVoucherPreUrlResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
            data?: GetPaymentVoucherPreUrlResp.UrlData
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get data() {
      return pb_1.Message.getWrapperField(
        this,
        GetPaymentVoucherPreUrlResp.UrlData,
        2
      ) as GetPaymentVoucherPreUrlResp.UrlData
    }
    set data(value: GetPaymentVoucherPreUrlResp.UrlData) {
      pb_1.Message.setWrapperField(this, 2, value)
    }
    get has_data() {
      return pb_1.Message.getField(this, 2) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
      data?: ReturnType<typeof GetPaymentVoucherPreUrlResp.UrlData.prototype.toObject>
    }): GetPaymentVoucherPreUrlResp {
      const message = new GetPaymentVoucherPreUrlResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      if (data.data != null) {
        message.data = GetPaymentVoucherPreUrlResp.UrlData.fromObject(data.data)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
        data?: ReturnType<typeof GetPaymentVoucherPreUrlResp.UrlData.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.data != null) {
        data.data = this.data.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.has_data) writer.writeMessage(2, this.data, () => this.data.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetPaymentVoucherPreUrlResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new GetPaymentVoucherPreUrlResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          case 2:
            reader.readMessage(
              message.data,
              () => (message.data = GetPaymentVoucherPreUrlResp.UrlData.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): GetPaymentVoucherPreUrlResp {
      return GetPaymentVoucherPreUrlResp.deserialize(bytes)
    }
  }
  export namespace GetPaymentVoucherPreUrlResp {
    export class UrlData extends pb_1.Message {
      #one_of_decls: number[][] = []
      constructor(
        data?:
          | any[]
          | {
              url?: string
              key?: string
              download_url?: string
            }
      ) {
        super()
        pb_1.Message.initialize(
          this,
          Array.isArray(data) ? data : [],
          0,
          -1,
          [],
          this.#one_of_decls
        )
        if (!Array.isArray(data) && typeof data == 'object') {
          if ('url' in data && data.url != undefined) {
            this.url = data.url
          }
          if ('key' in data && data.key != undefined) {
            this.key = data.key
          }
          if ('download_url' in data && data.download_url != undefined) {
            this.download_url = data.download_url
          }
        }
      }
      get url() {
        return pb_1.Message.getFieldWithDefault(this, 1, '') as string
      }
      set url(value: string) {
        pb_1.Message.setField(this, 1, value)
      }
      get key() {
        return pb_1.Message.getFieldWithDefault(this, 2, '') as string
      }
      set key(value: string) {
        pb_1.Message.setField(this, 2, value)
      }
      get download_url() {
        return pb_1.Message.getFieldWithDefault(this, 3, '') as string
      }
      set download_url(value: string) {
        pb_1.Message.setField(this, 3, value)
      }
      static fromObject(data: { url?: string; key?: string; download_url?: string }): UrlData {
        const message = new UrlData({})
        if (data.url != null) {
          message.url = data.url
        }
        if (data.key != null) {
          message.key = data.key
        }
        if (data.download_url != null) {
          message.download_url = data.download_url
        }
        return message
      }
      toObject() {
        const data: {
          url?: string
          key?: string
          download_url?: string
        } = {}
        if (this.url != null) {
          data.url = this.url
        }
        if (this.key != null) {
          data.key = this.key
        }
        if (this.download_url != null) {
          data.download_url = this.download_url
        }
        return data
      }
      serialize(): Uint8Array
      serialize(w: pb_1.BinaryWriter): void
      serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter()
        if (this.url.length) writer.writeString(1, this.url)
        if (this.key.length) writer.writeString(2, this.key)
        if (this.download_url.length) writer.writeString(3, this.download_url)
        if (!w) return writer.getResultBuffer()
      }
      static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UrlData {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
          message = new UrlData()
        while (reader.nextField()) {
          if (reader.isEndGroup()) break
          switch (reader.getFieldNumber()) {
            case 1:
              message.url = reader.readString()
              break
            case 2:
              message.key = reader.readString()
              break
            case 3:
              message.download_url = reader.readString()
              break
            default:
              reader.skipField()
          }
        }
        return message
      }
      serializeBinary(): Uint8Array {
        return this.serialize()
      }
      static deserializeBinary(bytes: Uint8Array): UrlData {
        return UrlData.deserialize(bytes)
      }
    }
  }

  /**
      /pay/cancel_inner_pay_order/
       取消内部的支付订单
       **/
  export class CancelInnerPayOrderReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
            order_id?: number
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('order_id' in data && data.order_id != undefined) {
          this.order_id = data.order_id
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get order_id() {
      return pb_1.Message.getFieldWithDefault(this, 2, 0) as number
    }
    set order_id(value: number) {
      pb_1.Message.setField(this, 2, value)
    }
    static fromObject(data: {
      header?: ReturnType<typeof ReqHeader.prototype.toObject>
      order_id?: number
    }): CancelInnerPayOrderReq {
      const message = new CancelInnerPayOrderReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      if (data.order_id != null) {
        message.order_id = data.order_id
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
        order_id?: number
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.order_id != null) {
        data.order_id = this.order_id
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.order_id != 0) writer.writeInt64(2, this.order_id)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CancelInnerPayOrderReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new CancelInnerPayOrderReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          case 2:
            message.order_id = reader.readInt64()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): CancelInnerPayOrderReq {
      return CancelInnerPayOrderReq.deserialize(bytes)
    }
  }
  export class CancelInnerPayOrderResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
    }): CancelInnerPayOrderResp {
      const message = new CancelInnerPayOrderResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CancelInnerPayOrderResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new CancelInnerPayOrderResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): CancelInnerPayOrderResp {
      return CancelInnerPayOrderResp.deserialize(bytes)
    }
  }
}
